import MuiTabs from "@mui/material/Tabs";
import type { TabsProps as MuiTabsProps } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import type { HTMLAttributes, ReactNode } from "react";

export interface TabsProps extends Omit<MuiTabsProps, "indicatorColor"> {
  name?: string;
  indicatorColor?: MuiTabsProps["indicatorColor"] | "inherit";
}

function TabsBase({
  children,
  name,
  textColor,
  indicatorColor,
  variant,
  scrollButtons,
  orientation,
  value,
  centered,
  onChange,
  sx,
}: TabsProps) {
  const legacyProps = {
    name,
    textColor,
    indicatorColor,
    variant,
    scrollButtons,
    orientation,
    value,
    centered,
    onChange,
    sx,
  } as unknown as MuiTabsProps;

  return <MuiTabs {...legacyProps}>{children}</MuiTabs>;
}

type TabsComponent = typeof TabsBase & {
  Tab: typeof Tab;
};

export const Tabs = TabsBase as TabsComponent;
Tabs.Tab = Tab;

export interface TabPanelProps extends HTMLAttributes<HTMLDivElement> {
  index: number;
  label?: string;
  value: unknown;
  children?: ReactNode;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}
